export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20man%20portrait%20in%20casual%20style%2C%20clean%20studio%20lighting%2C%20friendly%20expression%2C%20simple%20neutral%20background%2C%20professional%20headshot%20style%2C%20warm%20natural%20tones&width=120&height=120&seq=avatar-01&orientation=squarish',
    role: '资深韩漫读者',
    rating: 5,
    content: '炮渣漫画网的更新速度简直太给力了！每次有新章节出来都是第一时间就能看到，翻译质量也很高，而且完全免费，真的太良心了。',
  },
  {
    id: 2,
    name: '深夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20young%20woman%20portrait%2C%20minimalist%20studio%20lighting%2C%20warm%20smile%2C%20simple%20background%2C%20professional%20headshot%20aesthetic%2C%20clean%20neutral%20tones&width=120&height=120&seq=avatar-02&orientation=squarish',
    role: '漫画UP主',
    rating: 5,
    content: '作为一个漫画视频创作博主，我每天都在炮渣漫画网上找素材。这里分类清晰、搜索方便，帮我节省了大量找漫时间。推荐给所有韩漫爱好者！',
  },
  {
    id: 3,
    name: '漫画控阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20man%20casual%20portrait%20with%20glasses%2C%20studio%20lighting%2C%20warm%20expression%2C%20simple%20minimal%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-03&orientation=squarish',
    role: '漫画社区版主',
    rating: 5,
    content: '从三年前开始用炮渣漫画网，看着它一步步成长壮大。漫画种类越来越丰富，界面也越来越好用了。尤其是无删减版本，还原度非常高。',
  },
  {
    id: 4,
    name: '爱漫小七',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20with%20long%20hair%2C%20soft%20studio%20lighting%2C%20gentle%20smile%2C%20minimal%20background%2C%20professional%20headshot%20style%2C%20warm%20aesthetic&width=120&height=120&seq=avatar-04&orientation=squarish',
    role: '插画师',
    rating: 5,
    content: '作为一名插画师，我对漫画画风要求很高。炮渣上的韩漫画风真的太精美了，尤其是《某天成为公主》的画师Spoon，每一帧都可以当壁纸！',
  },
  {
    id: 5,
    name: '追漫老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%2C%20friendly%20expression%2C%20studio%20lighting%2C%20clean%20neutral%20background%2C%20professional%20headshot%20photography%2C%20warm%20approachable%20look&width=120&height=120&seq=avatar-05&orientation=squarish',
    role: '十年韩漫粉',
    rating: 5,
    content: '关注韩国漫画十多年了，炮渣漫画网是我用过体验最好的平台。排行榜更新及时，热门推荐也很准，每次都能找到我想看的新漫。',
  },
  {
    id: 6,
    name: '看书入迷',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20woman%20with%20short%20hair%20portrait%2C%20bright%20studio%20lighting%2C%20happy%20expression%2C%20simple%20background%2C%20professional%20headshot%20photography%2C%20warm%20and%20inviting&width=120&height=120&seq=avatar-06&orientation=squarish',
    role: '大学生',
    rating: 5,
    content: '每天晚上的必备节目就是来炮渣刷一会儿漫画！学校宿舍网不太好，但炮渣的加载速度很快，体验很流畅。宿舍几个室友都是炮渣的忠实用户。',
  },
];